export default function CircularMenuButton(props) {
  const { handleClick, iconClass } = props;

  return <a href="#" onClick={handleClick} className={`menu-item fas ${iconClass}`}></a>;
}
